import { makeStyles } from '@material-ui/core/styles';
import { MDSLogo } from '@marqvision/mds-v2';

const useStyles = makeStyles(() => ({
  box: {
    margin: '64px 20px 20px',
    cursor: 'pointer',
  },
}));

export const LogoWordmark = () => {
  const classes = useStyles();

  return (
    <div className={classes.box} onClick={() => (window.location.href = 'https://www.marqvision.com')}>
      <MDSLogo logoType="ai" size={32} color="black" />
    </div>
  );
};
